import React, {Component} from 'react';
import PropTypes from "prop-types";
import _ from "lodash";
import {Form, Control, Fieldset} from 'react-redux-form';
import Loading from "../loading";
import { confirmAlert } from 'react-confirm-alert';
import {formatMoney} from "accounting-js";
import {toInt} from "../parsers";

const propTypes = {
	expenses: PropTypes.object.isRequired,
	concepts: PropTypes.object.isRequired,
	permissions: PropTypes.array.isRequired,
	projectExpensesSave: PropTypes.func.isRequired
}


class ProjectExpensesEditForm  extends Component{
	render(){
		const {expenses, permissions} = this.props;
		let totalExpenses = 0;
		_.map(expenses.data.project_expenses, (o) => totalExpenses += o.total);
		let pc = _.find(permissions, (o) => {return o==='Create'});
		return (
			<Form model="project.expenses.data" className="columns is-centered" onSubmit={(values) => this._handleSubmit(values)} onSubmitFailed={() => this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario', 'danger')}>
				<div className="column">
					{this.state.expenseEditShow ? <ExpenseEditModal expenseIndex={this.state.expenseIndex} active={this.state.expenseEditShow} closeModal={() => this._toggleModal()} {...this.props}/> : ''}
					<div className="field is-grouped is-grouped-right">
						<div className="control">
							<button type="button" className="button is-primary" onClick={() => this._addExpense()} disabled={expenses.editable && !expenses.isFetching ? false:true}>
					        <span className="icon">
					            <i className="fa fa-plus" />
					        </span>
								<span>Agregar gasto</span>
							</button>
						</div>
					</div>

					<table className="table is-fullwidth no-margin project-goal-table">
						<thead>
						<tr>
							<th>No.</th>
							<th>Concepto del gasto</th>
							<th>Unidad de medida</th>
							<th>Cantidad</th>
							<th className="has-text-right">Valor</th>
							<th className="has-text-right">Total</th>
							<th>Acciones</th>
						</tr>
						</thead>
						<tbody>
						{!expenses.isFetching ?
							!_.isEmpty(expenses.data.project_expenses) ?
								_.map(expenses.data.project_expenses, (row, k) => {
									let expensesRevision = !_.isEmpty(expenses.revision.body) ? _.find(expenses.revision.body, {id: row.id}) : undefined;
									let expenseDisable = this._blockFields(row.id);
									return [
										<tr key={`expenses-table-row-${k}`}>
											<td rowSpan={expensesRevision ? 2:1} className={expensesRevision && expensesRevision.status ? `is-${expensesRevision.status}`:''}>{k + 1}</td>
											<td>{row.expense_concept.name}</td>
											<td>{row.expense_unit.name}</td>
											<td>{row.quantity}</td>
											<td className="has-text-right">{formatMoney(row.amount)}</td>
											<td className="has-text-right">{formatMoney(row.total)}</td>
											<td>
												<div className="field is-grouped">
													<div className="control">
														<button className="button is-info" type="button" onClick={() => this._editExpense(k, row)} disabled={expenseDisable}>
															<i className="fa fa-edit"/>
														</button>
													</div>
													<div className="control">
														<button className="button is-danger" type="button" onClick={() => this._removeExpense(k)} disabled={expenseDisable}>
															<i className="fa fa-trash-o"/>
														</button>
													</div>
												</div>
											</td>
										</tr>,
										expensesRevision ?
										<tr key={`comment-${k}`}>
											<td colSpan="6">
									            <span className={`tag ${expensesRevision.status ? `is-${expensesRevision.status}`:''}`}>
										            {`Comentarios: ${expensesRevision.comment}`}
									            </span>
											</td>
										</tr> :null
									]
								})
								:<tr>
									<td colSpan="7" className="has-text-center">
										<h2>No hay gastos registrados</h2>
									</td>
								</tr>
							:<tr><td colSpan={7}><Loading message="Buscando..."/></td></tr>}
						<tr>
							<th className="has-text-right is-inm-purple" colSpan={6}><strong className="has-text-white-bis">{formatMoney(totalExpenses)}</strong></th>
							<th className="is-inm-purple"></th>
						</tr>
						</tbody>
					</table>

					<div className="field is-grouped is-grouped-right">
						<div className="control">
							<button type="button" className="button is-large" onClick={() => this.props.history.goBack()}>Regresar</button>
						</div>
						{pc ?
						<div className="control">
							<Control.button model="project.expenses.data" className="button is-large is-inm-purple" type="submit" >Guardar</Control.button>
						</div>:''}
					</div>
				</div>
			</Form>
		)
	}

	constructor(){
		super();
		this.state = {
			expenseIndex: undefined,
			expenseEditShow: false
		}

	}

	_handleSubmit(values) {
		const {state, municipality, modality} = this.props.match.params;
		this.props.projectExpensesSave(modality, state, municipality, values);
	}

	_editExpense(expenseIndex,row){
		this.props.change(`project.expenses.edit`,{
			temp_expense_id: row.id ? row.id:undefined,
			temp_expense_concept_id: row.expense_concept_id,
			temp_expense_unit_id: row.expense_unit_id,
			temp_quantity: row.quantity,
			temp_amount: row.amount,
		});

		this.setState({
			expenseIndex: expenseIndex,
			expenseEditShow: true
		})
	}

	_addExpense(){
		this.setState({
			expenseEditShow: true
		})
	}

	_removeExpense(expenseIndex) {
		confirmAlert({
			title: '¿Esta seguro?',
			message: '¿Estás seguro/(a) de eliminar el gasto?',
			confirmLabel: 'Eliminar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this.props.remove('project.expenses.data.project_expenses',expenseIndex)
		});
	}

	_toggleModal() {
		this.setState({
			expenseIndex: undefined,
			expenseEditShow: false
		});

		this.props.change(`project.expenses.edit`,{});
	}

	_blockFields(id) {
		let { expenses } = this.props;
		let response = false;
		let editable = expenses.editable;
		let expensesRevision = !_.isEmpty(expenses.revision) ? expenses.revision.body : undefined;

		if(!_.isEmpty(expensesRevision) && !expenses.isFetching){
			let allow =_.find(expensesRevision, {allow_edit: 'true', id: id}) ? true : false;
			if(editable && allow){
				response = false;
			}else{
				response = true;
			}
		}else if(editable && !expenses.isFetching){
			response = false;
		}else {
			response = true;
		}

		return response;
	}
}

class ExpenseEditModal extends Component{
	render(){
		let {expenses, concepts} = this.props;
		let conceptData = _.find(concepts.list,{id: expenses.edit.temp_expense_concept_id});
		let unitslist = conceptData ? conceptData.units:[];
		return(
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal}></div>
				<div className="modal-card">
					<header className="modal-card-head">
						<p className="modal-card-title">Gasto de coordinación</p>
						<button type="button" onClick={this.props.closeModal} className="delete"
						        aria-label="close"></button>
					</header>
					<div className="modal-card-body">
						<Fieldset model="project.expenses.edit">
							<div className="field">
								<div className="control">
									<label htmlFor="temp_expense_concept_id" className="label">Concepto <span className="small has-text-danger">*</span></label>
									<div className="select">
										<Control.select id="temp_expense_concept_id" model=".temp_expense_concept_id" parser={ toInt } changeAction={(model,value) => this._changeConcept(model,value)}>
											<option value="">--- Concepto ---</option>
											{_.map(concepts.list,(st, k) => {
												return <option value={st.id} key={k}>{st.name}</option>
											})}
										</Control.select>
									</div>
									{expenses.edit && expenses.edit.temp_expense_concept_id ?
										'':<small className="help has-text-danger">El concepto es obligatorio</small>}
								</div>
							</div>
							<div className="field">
								<div className="control">
									<label htmlFor="temp_expense_unit_id" className="label">Unidad de medida <span className="small has-text-danger">*</span></label>
									<div className={`select`}>
										<Control.select id="temp_expense_unit_id" model=".temp_expense_unit_id" parser={ toInt }>
											<option value="">--- Unidad de medida ---</option>
											{_.map(unitslist,(st, k) => {
												return <option value={st.id} key={k} className={!st.invoiceable ? 'has-text-primary':''}>{!st.invoiceable ? `${st.name} (No Facturable)`:st.name}</option>
											})}
										</Control.select>
									</div>
									{expenses.edit && expenses.edit.temp_expense_unit_id ?
										'':<small className="help has-text-danger">La unidad es obligatoria</small>}
									{this._validUnit() ?
										<small className="help has-text-danger">Unidad duplicada</small>:''}
								</div>
							</div>
							<div className="field is-grouped">
								<div className="control">
									<label htmlFor="temp_quantity" className="label">Cantidad <span className="small has-text-danger">*</span></label>
									<Control.text type="number" min="0" model=".temp_quantity" id="temp_quantity" className="input" />
									{expenses.edit && expenses.edit.temp_quantity ?
										'':<small className="help has-text-danger">Cantidad es obligatoria</small>}
								</div>
								<div className="control">
									<label htmlFor="temp_amount" className="label">Gasto <span className="small has-text-danger">*</span></label>
									<Control.text model=".temp_amount" className="input" id="temp_expense" type="number" step="0.01" min="0"  placeholder="$"/>
									{expenses.edit && expenses.edit.temp_quantity ?
										'':<small className="help has-text-danger">Gasto obligatorio</small>}
								</div>
							</div>
							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<button type="button" className="button" onClick={this.props.closeModal}>Cerrar</button>
								</div>
								<div className="control">
									<button type="button" className="button is-primary" onClick={() => this._saveExpense()} disabled={this._validUnit()}>
										Guardar
									</button>
								</div>
							</div>
							<p className="has-text-grey has-text-right is-small">Los campos indicados con <span className="small has-text-danger">*</span> son obligatorios.</p>
						</Fieldset>
					</div>
				</div>
			</div>
		)
	}

	_validUnit(){
		let {expenses, expenseIndex} = this.props;
		let {edit} = expenses;
		let response = false;

		if(edit.temp_expense_unit_id){
			let foundUnit = _.find(expenses.data.project_expenses, {expense_unit_id: edit.temp_expense_unit_id})
			let validate = foundUnit ? true:false;
			if(_.isNumber(expenseIndex) && edit.temp_expense_unit_id === expenses.data.project_expenses[expenseIndex].expense_unit_id){
				response = false;
			}else {
				response = validate;
			}
		}else {
			response = false;
		}

		return response;
	}

	_saveExpense(){
		let {expenseIndex, expenses, concepts} = this.props;
		let {edit} = expenses;

		if(edit.temp_expense_concept_id &&
			edit.temp_expense_unit_id &&
			edit.temp_quantity &&
			edit.temp_amount){
			let total = _.toNumber(edit.temp_quantity) * _.toNumber(edit.temp_amount);
			let conceptData = _.find(concepts.list, {id: edit.temp_expense_concept_id});
			let unitData = _.find(conceptData.units, {id: edit.temp_expense_unit_id});

			if(_.isNumber(expenseIndex)){
				this.props.change(`project.expenses.data.project_expenses[${expenseIndex}]`,{
					...expenses.data.project_expenses[expenseIndex],
					expense_concept_id: edit.temp_expense_concept_id,
					expense_unit_id: edit.temp_expense_unit_id,
					quantity: _.toNumber(edit.temp_quantity),
					amount: edit.temp_amount,
					total: total,
					expense_concept: {
						name: conceptData.name
					},
					expense_unit: {
						name: unitData.name
					}
				});
			}else {
				this.props.add(`project.expenses.data.project_expenses`,{
					expense_concept_id: edit.temp_expense_concept_id,
					expense_unit_id: edit.temp_expense_unit_id,
					quantity: _.toNumber(edit.temp_quantity),
					amount: edit.temp_amount,
					total: total,
					expense_concept: {
						name: conceptData ? conceptData.name:''
					},
					expense_unit: {
						name: unitData ? unitData.name:''
					}
				});
			}

			this.props.closeModal();
		}else {
			alert('Hay errores en el formulario');
		}

	}

	_changeConcept(model,value){
		this.props.change(model,value);
		this.props.change('project.expenses.edit.temp_expense_unit_id',undefined);
	}
}

ProjectExpensesEditForm.propTypes = propTypes;

export default ProjectExpensesEditForm;


// WEBPACK FOOTER //
// ./src/elements/project/expenses.jsx